module.exports = __webpack_public_path__ + "static/media/vidulcert.7408954e.jpeg";